module.exports = __webpack_public_path__ + "static/media/RobotoMono-Regular.b4618f1f.ttf";